import * as moment from "moment";
// import * as mime from 'mime';
// import { MEEZAN_CONSTANTS } from './constants';
import { FormControl, FormArray } from "@angular/forms";
import { MatSnackBar } from "@angular/material";
import { decrypt } from "./utilityFunctions";
import { HEC_CONSTANTS } from "./constants";

export class CommonHelper {
	constructor(public _snackBar: MatSnackBar) { }

	// static MOBILE_REGEX = /^(?:\+971|00971|0)(?:2|3|4|6|7|9|50|51|52|55|56)[0-9]{7}$/;
	static MOBILE_REGEX = /^((?:(92)|(0))(3)[0-9]{9})$/;
	static PHONE_REGEX = /^(([0]{1})(((2)|[4-9]){1})([0-9]{9}))$/;
	static FORM_DATE_REGEX = /[0-9]{4}-[0-9]{2}-[0-9]{2}$/;
	static SERVICE_DATE_REGEX =
		/[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}/;
	static EMAIL_REGEX = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
	static CNIC_REGEX = /^[0-9]$/;
	//     static fileExt: string = HEC_CONSTANTS.FILE_PROPERTIES_COURSERA.fileExt;
	//   static maxSize: number = HEC_CONSTANTS.FILE_PROPERTIES_COURSERA.maxSize;

	// static MOBILE_REGEX = /^(+92|0)(3)[0-9]{9}$/;
	// static MOBILE_REGEX = /^(03)?[0-9]{9}$/;

	/*
		Convert file to byte[]
		@param: file: File
		@param: callback: Function | its a callback function
		@return: Uint8Array
	*/
	static fileToBytes = (file: File, callback: Function) => {
		let reader = new FileReader();
		reader.readAsArrayBuffer(file[0]);
		reader.onloadend = () => {
			let unitArray = new Uint8Array((reader as any).result);
			let bytes = Array.prototype.slice.call(unitArray);
			callback(bytes, file[0].type);
		};
	};

	/*
		Convert file to byte[]
		@param: file: FileList
		@param: callback: Function | its a callback function
		@return: Uint8Array
	*/
	static filesToBytes = (
		files: FileList,
		bytesCallback: Function,
		callback: Function
	) => {
		let processed = 0;
		[].forEach.call(files, (file: File, index) => {
			let reader = new FileReader();
			reader.readAsArrayBuffer(file);
			reader.onloadend = () => {
				processed++;
				let unitArray = new Uint8Array((reader as any).result);
				let bytes = Array.prototype.slice.call(unitArray);
				bytesCallback(bytes, index);

				// When all async operation completed then call final callback function
				if (processed === files.length) {
					callback();
				}
			};
		});
	};

	/*
		Calculate rating star width in %
		@param: rating: number
		@return: number
	*/
	static calcRatingWidth = (rating: number) => {
		return (rating * 100) / 5;
	};

	/*
		Mark from controls state is touched
		@param: formGroup: FormGroup | NgForm
	*/
	static markFormGroupTouched = (formGroup) => {
		(<any>Object).values(formGroup.controls).forEach((control) => {
			control.markAsTouched();

			if (control.controls) {
				CommonHelper.markFormGroupTouched(control);
			}
		});
	};

	/*
		Mark from controls state is untouched
		@param: formGroup: FormGroup | NgForm
	*/
	static markFormGroupUnTouched = (formGroup) => {
		(<any>Object).values(formGroup.controls).forEach((control) => {
			control.markAsUntouched();
			if (control.controls) {
				CommonHelper.markFormGroupUnTouched(control);
			}
		});
	};

	/*
	   Remove empty property in object
	   @param: obj: Object | Any
   */

	static validate(f): boolean {
		if (f.status === "VALID") {
			return true;
		}
	}

	static convertUndefinedToNull(obj) {
		for (var prop in obj) {
			if (obj[prop] === undefined) {
				obj[prop] = null;
			}
		}
	}

	/*
		Remove empty property in object
		@param: obj: Object | Any
	*/
	static removeEmptyPropFromObject(obj) {
		for (var prop in obj) {
			if (
				obj[prop] === null ||
				obj[prop] === undefined ||
				obj[prop] === ""
			) {
				delete obj[prop];
			}
		}
	}

	/*
		Remove list of properties in object
		@param: properties: [] | Any, obj: Object | any
	*/
	static removePropArrFromObject(propArr, obj) {
		propArr.forEach((property) => {
			delete obj[property];
		});
	}

	static convertCamelCaseToSentence(text: string) {
		var result = text.replace(/([A-Z])/g, " $1");
		var finalResult = result.charAt(0).toUpperCase() + result.slice(1);
		return finalResult;
	}

	/*
	   Append non existent  properties of source into target object
	   @param: properties: [] | Any, obj: Object | any
   */
	static unionPropFromSourceToTarget(source, target) {
		for (let key in source) {
			if (!target[key] && target[key] != "") target[key] = source[key];
		}
	}

	/*
	   If a key doesnt exist in myObj but form has a field named after that key then,
	   add key and give it null value
   */
	static unionPropFromFormToObject(formControls, myObj) {
		for (let key in formControls) {
			if (!myObj[key] && myObj[key] != "") myObj[key] = null;
		}
	}

	// Copy those values of form that have keys in model
	static valuesFromFormToModel(model, form) {
		for (var key of Object.keys(form)) {
			for (var modelKeys of Object.keys(model)) {
				if (key == modelKeys) {
					model[modelKeys] = form[key];
				} else {
				}
			}
		}
	}

	// Copy those values of form that have keys in model
	static valuesFromFormToModelAndRemoveExtra(model, form) {
		for (var key of Object.keys(form)) {
			for (var modelKeys of Object.keys(model)) {
				if (key == modelKeys) {
					model[modelKeys] = form[key];
				} else {
					delete form[key];
				}
			}
		}
	}

	// Copy those values of form that have keys in model
	static convertObjToArray(data) {
		let x = Object.keys(data);
		let y = Object.values(data);
		let combinedArray = [];
		for (let i = 0; i < x.length; i++) {
			combinedArray.push({
				label: CommonHelper.convertCamelCaseToSentence(x[i]),
				value: y[i],
			});
		}
		return combinedArray;
	}

	// Remove all those keys in serviceData that are not in formData
	// Remove all those keys in obj that are not in form
	static valuesFromServiceToForm(serviceData, formData) {
		var formKeys = Object.keys(formData);
		for (var serviceKeys of Object.keys(serviceData)) {
			if (formData.hasOwnProperty(serviceKeys)) {
			} else {
				delete serviceData[serviceKeys];
			}
		}
	}

	static setAvailableValuesToForm(model, form) {
		for (var modelKeys of Object.keys(model)) {
			for (var formControlsKeys of Object.keys(form.controls)) {
				if (modelKeys == formControlsKeys) {
					form.controls[formControlsKeys].setValue(model[modelKeys]);
				}
			}
		}
	}

	static setNullPropertiesToFalse(rowModel) {
		for (var key in rowModel) {
			//  if(rowModel[key] == null && typeof(key) == "boolean"){
			//      rowModel[key]=false
			//  }
		}
	}

	static getControlsOfForm(form) { }

	/* conversion of datatypes */
	static dataTypeConversion(model, payload) {
		for (let key in model) {
			if (typeof model[key] != typeof payload[key]) {
			}
		}
	}

	static getFormFieldStatus(Form) {
		for (let key in Form.controls) {
		}
	}

	/*
		Get user current position
		@return: Position
	*/
	static getUserCurrentPosition() {
		if (navigator.geolocation) {
			return new Promise((resolve) =>
				navigator.geolocation.getCurrentPosition(
					resolve,
					function error(error_message) {
						return new Promise((resolve) => {
							let pos: { coords: Coordinates };
							let coords: { latitude; longitude };
							coords.latitude = 25.276987;
							coords.longitude = 55.296249;
							pos.coords = coords as Coordinates;
							resolve(coords);
						});
					}
				)
			);
		} else {
			return new Promise((resolve) => {
				let pos: { coords: Coordinates };
				let coords: { latitude; longitude };
				coords.latitude = 25.276987;
				coords.longitude = 55.296249;
				pos.coords = coords as Coordinates;
				resolve(coords);
			});
		}
	}

	// static downloadBase64File(
	//     base64Data: string,
	//     fileName: string,
	//     fileType: string
	//   ) {
	//     const contentType = fileType;
	//     const sliceSize = 512;
	//     const byteCharacters = atob(base64Data);
	//     const byteArrays = [];

	//     for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	//       const slice = byteCharacters.slice(offset, offset + sliceSize);

	//       const byteNumbers = new Array(slice.length);
	//       for (let i = 0; i < slice.length; i++) {
	//         byteNumbers[i] = slice.charCodeAt(i);
	//       }

	//       const byteArray = new Uint8Array(byteNumbers);

	//       byteArrays.push(byteArray);
	//     }

	//     const blobData = new Blob(byteArrays, { type: contentType });

	//     if (window.navigator && window.navigator.msSaveOrOpenBlob) {
	//       //IE
	//       window.navigator.msSaveOrOpenBlob(blobData, fileName);
	//     } else {
	//       // chrome
	//       const blob = new Blob([blobData], { type: contentType });
	//       const url = window.URL.createObjectURL(blob);
	//       // window.open(url);
	//       const link = document.createElement('a');
	//       link.href = url;
	//       link.download = fileName;
	//       link.click();
	//     }
	//   }

	/*
		Convert MimeType
		@param: mimeType: String
	*/
	static trimMimeType(mimeType: string): string {
		if (mimeType.indexOf("/"))
			return mimeType.substring(
				mimeType.indexOf("/") + 1,
				mimeType.length
			);
		else return mimeType;
	}

	static removeCommaFromAddressField(address) {
		let lastCommaIndex = address.lastIndexOf(",");
		return address.slice(0, lastCommaIndex);
	}

	static convertToFormDateFormat(date) {
		let tempDate = new Date(date.split("[")[0]);

		// Add 5 hours to UTC date to convert to PKT
		let convertedDate = this.convertUTCDateToBrowserTimezone(tempDate);

		return convertedDate.substr(0, 10);
	}

	static convertUTCDateToBrowserTimezone(date) {
		// Convert to current browser time, i.e => PKT

		date = new Date(date);
		var months = {
			Jan: "01",
			Feb: "02",
			Mar: "03",
			Apr: "04",
			May: "05",
			Jun: "06",
			Jul: "07",
			Aug: "08",
			Sep: "09",
			Oct: "10",
			Nov: "11",
			Dec: "12",
		};
		let dateString = date.toString();
		let Year = dateString.substring(11, 15);
		let Month = dateString.substring(4, 7);
		let day = dateString.substring(8, 10);

		return new Date(Year + "-" + months[Month] + "-" + day).toISOString();
	}

	static convertMaximumTime(date) {
		let newDate = new Date(date);
		newDate.setMinutes(59);
		newDate.setSeconds(59);
		newDate.setMilliseconds(999);
		return newDate;
	}

	static convertToFormYearFormat(date) {
		return date.substr(0, 4);
	}

	static convertToServiceDateFormat(date) {
		return new Date(date).toISOString();
	}

	static convertUTCDateToLocalDateTime(date) {
		return new Date(date).toLocaleString().replace(",", "");
	}

	static convertUTCDateToLocalDate(date) {
		return new Date(date).toLocaleDateString().replace(",", "");
	}

	static convertAllDatesToFormDate(myObj) {
		for (let prop in myObj) {
			// Convert date string to form required format
			// "2019-03-28T10:36:04.521Z" -> "2019-03-28"
			if (
				prop.includes("date") ||
				this.SERVICE_DATE_REGEX.test(myObj[prop])
			) {
				myObj[prop] = this.convertToFormDateFormat(myObj[prop]);
			}
		}
	}

	static convertAllDatesToServiceDate(myObj) {
		for (let prop in myObj) {
			// Convert date string to form required format
			// "2019-03-28T10:36:04.521Z" -> "2019-03-28"
			if (
				prop.includes("date") ||
				this.FORM_DATE_REGEX.test(myObj[prop])
			) {
				myObj[prop] = this.convertToServiceDateFormat(myObj[prop]);
			}
		}
	}

	static performAddition(...args: any[]): number {
		var result = 0;
		for (var i = 0; i < args.length - 1; i++) {
			result += args[i] ? parseFloat(args[i]) : 0;
		}
		return result;
		// giving no of arguments to be added , the last argument must be a control
	}

	static performSubtraction(...args: any[]): number {
		var result = args[0] ? parseFloat(args[0]) : 0;
		for (var i = 1; i < args.length - 1; i++) {
			result -= args[i] ? parseFloat(args[i]) : 0;
		}
		return result;
		// giving no of arguments to be subtracted , the last argument must be a control
	}
	/*Date Compare method
	possible results :
	Date1 = Date2
	Date1 > Date2
	Date2 > Date1
	*/
	static compare_dates(date1, date2) {
		if (date1 > date2) return "Date1 > Date2";
		else if (date1 < date2) return "Date2 > Date1";
		else return "Date1 = Date2";
	}

	static convertObjectToModelType(myObj, model) {
		for (let prop in model) {
			// convert strings to numbers, according to model
			if (
				(typeof model[prop] == "number" ||
					prop.endsWith("CodeId") ||
					prop.endsWith("Id") ||
					prop.includes("Income")) &&
				myObj[prop] &&
				(myObj[prop] != "" || myObj[prop] == "")
			) {
				myObj[prop] = +myObj[prop];
			}

			// For checkboxes, default to false
			if (typeof model[prop] == "boolean" && !myObj[prop]) {
				myObj[prop] = false;
			}

			// Convert date string to service required format
			// "2019-03-02" -> 2019-03-28T10:36:04.521Z

			if (
				prop.includes("date") ||
				prop.includes("Date") ||
				this.FORM_DATE_REGEX.test(myObj[prop])
			) {
				// IF USER HAS SET THE DATE
				if (this.FORM_DATE_REGEX.test(myObj[prop])) {
					myObj[prop] = this.convertToServiceDateFormat(myObj[prop]);
				} else {
					// myObj[prop] = null
				}
			}
		}
	}

	static convertingListType(list, model) {
		let tempList = [];
		list.forEach((element) => {
			this.convertObjectToModelType(element, model);
			tempList.push(element);
		});
		return tempList;
	}

	static settingNullValues(list, model) {
		let tempList = [];
		list.forEach((element) => {
			this.unionPropFromFormToObject(model, element);
			tempList.push(element);
		});
		return tempList;
	}

	static setDeviations(deviationsObj, deviationsArr) {
		for (let obj of deviationsArr) {
			deviationsObj[obj.fieldName] = { msg: obj.errorMessage };
		}
	}

	static setTabAndTaskCode(payload, tabName, taskCode?) {
		payload.taskCode = taskCode ? taskCode : "NEW_APPLICATION";
		payload.tabCode = tabName;
	}

	// static downloadBase64File(
	// 	base64Data: string,
	// 	fileName: string,
	// 	fileType: string
	// ) {
	// 	const contentType = fileType;
	// 	const sliceSize = 512;
	// 	const byteCharacters = atob(base64Data);
	// 	const byteArrays = [];
	// 	for (
	// 		let offset = 0;
	// 		offset < byteCharacters.length;
	// 		offset += sliceSize
	// 	) {
	// 		const slice = byteCharacters.slice(offset, offset + sliceSize);
	// 		const byteNumbers = new Array(slice.length);
	// 		for (let i = 0; i < slice.length; i++) {
	// 			byteNumbers[i] = slice.charCodeAt(i);
	// 		}
	// 		const byteArray = new Uint8Array(byteNumbers);
	// 		byteArrays.push(byteArray);
	// 	}
	// 	const blobData = new Blob(byteArrays, { type: contentType });
	// 	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
	// 		//IE
	// 		window.navigator.msSaveOrOpenBlob(blobData, fileName);
	// 	} else {
	// 		// chrome
	// 		const blob = new Blob([blobData], { type: contentType });
	// 		const url = window.URL.createObjectURL(blob);
	// 		// window.open(url);
	// 		const link = document.createElement("a");
	// 		link.href = url;
	// 		link.download = fileName;
	// 		link.click();
	// 	}
	// }

	//old downloadBase64File function
	static downloadBase64File(base64Data: string, fileName: string, fileExt: string) {

		const contentType = this.getMimeType(fileExt);
		console.log(contentType)
		const sliceSize = 512;
		const byteCharacters = atob(base64Data);
		const byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
			const slice = byteCharacters.slice(offset, offset + sliceSize);

			const byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}

			const byteArray = new Uint8Array(byteNumbers);

			byteArrays.push(byteArray);
		}

		const blobData = new Blob(byteArrays, { type: contentType });

		if (window.navigator && window.navigator.msSaveOrOpenBlob) { //IE
			window.navigator.msSaveOrOpenBlob(blobData, fileName);
		} else { // chrome
			const blob = new Blob([blobData], { type: contentType });
			const url = window.URL.createObjectURL(blob);
			// window.open(url);
			const link = document.createElement('a');
			link.href = url;
			link.download = fileName;
			link.click();
			window.open(url,'_blank'); // download and preview options
		}

	}

	static openBase64InNewTab(base64Data: string, fileExt: string): void {
		const contentType = this.getMimeType(fileExt); // e.g., 'application/pdf'
		const byteCharacters = atob(base64Data);
		const byteNumbers = new Array(byteCharacters.length);
	  
		for (let i = 0; i < byteCharacters.length; i++) {
		  byteNumbers[i] = byteCharacters.charCodeAt(i);
		}
	  
		const byteArray = new Uint8Array(byteNumbers);
		const blob = new Blob([byteArray], { type: contentType });
		const blobUrl = URL.createObjectURL(blob);
	  
		window.open(blobUrl, '_blank'); // just opens, no download
	  }
	  

	static downloadPublicationBase64File(
		base64Data: string,
		fileName: string,
		fileType: string
	) {
		const contentType = fileType;
		const sliceSize = 512;
		const byteCharacters = atob(base64Data);
		const byteArrays = [];
		for (
			let offset = 0;
			offset < byteCharacters.length;
			offset += sliceSize
		) {
			const slice = byteCharacters.slice(offset, offset + sliceSize);
			const byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}
			const byteArray = new Uint8Array(byteNumbers);
			byteArrays.push(byteArray);
		}
		const blobData = new Blob(byteArrays, { type: contentType });
		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
			//IE
			window.navigator.msSaveOrOpenBlob(blobData, fileName);
		} else {
			// chrome
			const blob = new Blob([blobData], { type: contentType });
			const url = window.URL.createObjectURL(blob);
			// window.open(url);
			const link = document.createElement("a");
			link.href = url;
			link.download = fileName;
			link.click();
		}
	}

	static getMimeType(fileExt: string): string {
		let mimeType = null;
		if (fileExt == "pdf") {
			mimeType = "application/pdf";
		} else if (fileExt == "png") {
			mimeType = "image/png";
		} else if (fileExt == "jpeg" || fileExt == "jpg") {
			mimeType = "image/jpeg";
		}
		return mimeType;
	}

	// type = application/ms-excel
	// filename = testfile.xls
	// data = res.body

	// old code
	static downloadFileFromBlob(data: any, type: string, filename: string) {
		var blob = new Blob([data], { type: type.toString() });
		var blobURL = window.URL.createObjectURL(blob);
		var anchor = document.createElement("a");
		anchor.download = filename;
		anchor.href = blobURL;
		anchor.click();
	}

	// new code
	static downloadFileFromBlobNew(data: any, type: string, filename: string) {

		const blobURL = window.URL.createObjectURL(data);
	
		const anchor = document.createElement("a");
		anchor.href = blobURL;
		anchor.download = filename;
	
		document.body.appendChild(anchor);
		anchor.click();
	
		document.body.removeChild(anchor);
		window.URL.revokeObjectURL(blobURL);
	}

	static convertFileToBase64(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => {
				let base64Str = reader.result.toString();
				let base64 = base64Str.substring(
					base64Str.indexOf(",") + 1,
					base64Str.length - 1
				);
				resolve(base64);
			};
			reader.onerror = (error) => reject(error);
		});
	}

	static isValidFile(file, fileExtension, fileMaxSize): boolean {
		const extensions = fileExtension.split(",").map(function (x) {
			return x.toLocaleLowerCase().trim();
		}); // array of extensions
		const ext = file.name.toLowerCase().split(".").pop() || file.name; // file extension
		const fileSizeinKB = file.size / 1024;

		if (extensions.indexOf(ext) === -1) {
			//   this._snackBar.open('Error in uploading ' + file.name + ' due to invalid file type.', '', {
			//     duration: 3500,
			//     panelClass: ['error-snackbar']
			//   });

			return false;
		} else if (!file.name.match()) {
			file = [];
			//   this._snackBar.open('Invalid File Name', '', {
			//     duration: 3500,
			//     panelClass: ['error-snackbar']
			//   });

			return false;
		} else if (fileSizeinKB > fileMaxSize) {
			file = [];
			//   this._snackBar.open(file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.', '', {
			//     duration: 3500,
			//     panelClass: ['error-snackbar']
			//   });
			return false;
		} else {
			return true;
		}
	}

	static fileExtensionCheck(file, fileExtension): boolean {
		const extensions = fileExtension.split(",").map(function (x) {
			return x.toLocaleLowerCase().trim();
		}); // array of extensions
		const ext = file.name.toLowerCase().split(".").pop() || file.name; // file extension
		console.log(extensions);
		console.log(ext);
		if (extensions.indexOf(ext) === -1) {
			// this.sharedService.open('Error in uploading ' + file.name + ' due to invalid file type.', '', {
			//   duration: 3500,
			//   panelClass: ['error-snackbar']
			// });
			// this.sharedService.showError(
			//     'Error in uploading ' + file.name + ' due to invalid file type.',
			//     'OK',
			//     'success-snackbar'
			//   );
			console.log(extensions.indexOf(ext) <= -1);
			console.log("extension error");
			return false;
		} else {
			return true;
		}
	}

	static fileNameCheck(file): boolean {
		if (!file.name.match()) {
			file = [];
			// this._snackBar.open('Invalid File Name', '', {
			//   duration: 3500,
			//   panelClass: ['error-snackbar']
			// });
			// this.sharedService.showError(
			//     'Invalid File Name',
			//     'OK',
			//     'success-snackbar'
			//   );
			console.log("name error");

			return false;
		} else {
			return true;
		}
	}

	static fileSizeCheck(file, maxSize): boolean {
		const fileSizeinKB = file.size / 1024;
		if (fileSizeinKB > maxSize) {
			file = [];
			// this._snackBar.open(file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.', '', {
			//   duration: 3500,
			//   panelClass: ['error-snackbar']
			// });
			// this.sharedService.showError(
			//     file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.',
			//     'OK',
			//     'success-snackbar'
			//   );
			console.log("size error");

			return false;
		} else {
			return true;
		}
	}

	// static saveFile(data): void {
	//     const attachment = data;
	//     const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
	//     const fileName = "pending";
	//     const fileExt = ".xlsx";

	//     if (window.navigator && window.navigator.msSaveOrOpenBlob) {
	//       const byteCharacters = atob(attachment);
	//       const byteNumbers = new Array(byteCharacters.length);
	//       for (let i = 0; i < byteCharacters.length; i++) {
	//         byteNumbers[i] = byteCharacters.charCodeAt(i);
	//       }
	//       const byteArray = new Uint8Array(byteNumbers);
	//       const blob = new Blob([byteArray], { type: contentType });
	//       window.navigator.msSaveOrOpenBlob(blob, fileName + fileExt);
	//     }
	//     else {
	//       let a = document.createElement('a');
	//       a.href = 'data:application/octet-stream;base64,' + attachment;
	//       a.download = fileName + fileExt;
	//       document.body.appendChild(a);
	//       a.click();
	//       document.body.removeChild(a);
	//     }
	//   }

	//     static async prepareFilesList(e: Array<any>,fileUploader) {
	//         if(e.length > 1){
	//           return false;
	//         }
	//         let image = e[0];
	//         let test:File;
	//         let file = e[0];
	//         if (this.isValidFile(file)) {
	//           this.fileUploader = true;
	//         if (file.type !== 'application/pdf') {
	//         this.ng2ImgMax.compressImage(image, 0.575).subscribe(
	//           async result => {
	//             test = result;
	//           await this.setAttachmentsPayload(result);

	//           },
	//           error => {
	//             console.log(error);
	//             this.fileUploader = false;
	//           }
	//         );
	//         }else{
	//           await this.setAttachmentsPayload(image);
	//         }
	//         for (const item of e) {
	//           item.progress = 0;
	//           this.files.push(item);
	//         }

	//         this.uploadFilesSimulator(0);
	//       }else{
	//         e=undefined
	//         file=undefined
	//         this.fileDropRef.nativeElement.value = null
	//       }
	//       }

	//   static isValidFile(file):boolean {
	//     const extensions = (this.fileExt.split(',')).map(function (x) { return x.toLocaleLowerCase().trim(); }); // array of extensions
	//     const ext = file.name.toLowerCase().split('.').pop() || file.name; // file extension
	//     const fileSizeinKB = file.size / 1024;

	//     if (extensions.indexOf(ext) === -1) {
	//       this.isImageAlert = true;
	//       this._snackBar.open('Error in uploading ' + file.name + ' due to invalid file type.', '', {
	//         duration: 3500,
	//         panelClass: ['error-snackbar']
	//       });
	//       file=[];
	//       this.cdr.detectChanges();
	//       setTimeout(() => {
	//         this.isImageAlert = false;
	//         this.cdr.detectChanges();
	//       }, 3000);
	//       return false;
	//     } else if (!file.name.match()) {
	//       this.isImageAlert = true;
	//       file=[];
	//       this._snackBar.open('Invalid File Name', '', {
	//         duration: 3500,
	//         panelClass: ['error-snackbar']
	//       });
	//       this.cdr.detectChanges();
	//       setTimeout(() => {
	//         this.isImageAlert = false;
	//         this.cdr.detectChanges();
	//       }, 3000);
	//       return false;
	//     }
	//     else if (fileSizeinKB > this.maxSize) {
	//       file=[];
	//       this.isImageAlert = true
	//       this._snackBar.open(file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.', '', {
	//         duration: 3500,
	//         panelClass: ['error-snackbar']
	//       });
	//       this.cdr.detectChanges();
	//       setTimeout(() => {
	//         this.isImageAlert = false;
	//         this.cdr.detectChanges();
	//       }, 3000);
	//       return false;
	//     }
	//     return true;
	//   }

	//   private uploadFilesSimulator(index: number):void {
	//     setTimeout(() => {
	//       if (index === this.files.length) {
	//         return;
	//       } else {
	//         const progressInterval = setInterval(() => {
	//           if (this.files[index].progress === 100) {
	//             clearInterval(progressInterval);
	//             this.uploadFilesSimulator(index + 1);
	//             this.fileUploader=false;
	//             this.cdr.detectChanges();
	//           } else {
	//             this.files[index].progress += 5;
	//           }
	//         }, 200);
	//       }
	//     }, 1000);
	//   }

	//   static async setAttachmentsPayload(file) {
	//     this.attachmentBase64 = (await this.convertFileToBase64(file)).toString();
	//   }

	// static downloadBase64File(base64Data: string, fileName: string, fileExt: string) {

	//     // const contentType = this.getMimeType(fileExt);
	//     const sliceSize = 512;
	//     const byteCharacters = atob(base64Data);
	//     const byteArrays = [];

	//     for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	//         const slice = byteCharacters.slice(offset, offset + sliceSize);

	//         const byteNumbers = new Array(slice.length);
	//         for (let i = 0; i < slice.length; i++) {
	//             byteNumbers[i] = slice.charCodeAt(i);
	//         }

	//         const byteArray = new Uint8Array(byteNumbers);

	//         byteArrays.push(byteArray);
	//     }

	//     const blobData = new Blob(byteArrays, { type: contentType });

	//     if (window.navigator && window.navigator.msSaveOrOpenBlob) { //IE
	//         window.navigator.msSaveOrOpenBlob(blobData, fileName);
	//     } else { // chrome
	//         const blob = new Blob([blobData], { type: contentType });
	//         const url = window.URL.createObjectURL(blob);
	//         // window.open(url);
	//         const link = document.createElement('a');
	//         link.href = url;
	//         link.download = fileName;
	//         link.click();
	//     }

	// }

	// static getMimeType(fileExt: string): string {
	//     return mime.getType(fileExt);
	// }

	// static openBase64File(base64Data: string, fileExt: string) {

	//     let fileWindow = window.open("")
	//     fileWindow.document.write(`<iframe style="width:100%; height:100%; overflow:hidden;" src=data:${mime.getType(fileExt)};base64,${encodeURI(base64Data)}></iframe>`)

	// }

	static delay(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms));
	}

	static getDateInFormat(format: string) {
		return moment().format(format);
	}

	static changeDateFormat(value: string, format: string) {
		return moment(value).format(format);
	}

	static allowedViewExtension(filePath: string): boolean {
		let fileExt = filePath.substring(filePath.lastIndexOf(".") + 1);
		let allowedExtension = [
			"pdf",
			"png",
			"jpg",
			"jpeg",
			"svg",
			"tiff",
			"jfif",
		];
		let isAllowed = false;
		for (let allowedExt of allowedExtension) {
			if (allowedExt.toLowerCase() === fileExt.toLowerCase()) {
				isAllowed = true;
				break;
			}
		}
		return isAllowed;
	}

	static keyPress(event: any) {
		const pattern = /[0-9\+\ ]/;
		if (!pattern.test(event.key)) {
			event.preventDefault();
		}
	}

	// static  showError(message, action) {
	// 	this._snackBar.open(message, action, {
	// 		duration: 350000,
	// 		panelClass: ['error-snackbar']
	// 	});
	// }

	static base64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
		const byteCharacters = atob(b64Data);
		const byteArrays = [];

		for (
			let offset = 0;
			offset < byteCharacters.length;
			offset += sliceSize
		) {
			const slice = byteCharacters.slice(offset, offset + sliceSize);

			const byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}

			const byteArray = new Uint8Array(byteNumbers);
			byteArrays.push(byteArray);
		}

		const blob = new Blob(byteArrays, { type: contentType });
		return blob;
	};

	static checkAdminRole = (): boolean => {
		if (localStorage.getItem("esp-profile-details")) {
			let d = JSON.parse(
				decrypt(localStorage.getItem("esp-profile-details"))
			);
		const roleList = d.getSpRole;
		return roleList.some((role) => {
			const roleValue = role.role || role[1];
			return (
				roleValue == HEC_CONSTANTS.UserRoles.ASSISTANT ||
				roleValue == HEC_CONSTANTS.UserRoles.FINANCE ||
				roleValue == HEC_CONSTANTS.UserRoles.AD ||
				roleValue == HEC_CONSTANTS.UserRoles.DD ||
				roleValue == HEC_CONSTANTS.UserRoles.DIR ||
				roleValue == HEC_CONSTANTS.UserRoles.ED
			);
		});
		}
	};
}
